import React from 'react';
import { Tabs } from '@fikasio/react-ui-components';
import { Organization } from 'services/organizations/types';
import OrganizationInformationsForm from './OrganizationInformationsForm';
import OrganizationMembersTable from './OrganizationMembersTable';

export interface OrganizationViewProps {
  defaultTab?: string,
  organization: Organization,
}

const OrganizationView = ({
  defaultTab,
  organization,
}: OrganizationViewProps) => (
  <div>
    <Tabs
      className="mb-3"
      defaultValue={defaultTab || 'INFOS'}
      options={[
        {
          content: (
            <OrganizationInformationsForm
              organization={organization}
            />
          ),
          label: 'Informations',
          value: 'INFOS',
        },
        {
          content: (
            <OrganizationMembersTable
              organization={organization}
            />
          ),
          label: 'Membres',
          value: 'MEMBERS',
        },
      ]}
    />
  </div>
);

export default OrganizationView;
